import * as CONST from '../ActionTypes';
import * as util from './util';

/**
 * 新規登録
 */
export const updateCustomer = (accessToken, param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/update`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((payload) => {
      if (payload.status === 200) {
        dispatch(util.actionType(CONST.UPDATE_CUSTOMER_SUCCESS, null));
        dispatch(util.unLoading());
      } else {
        dispatch(
          util.actionType(
            CONST.UPDATE_CUSTOMER_FAILURE,
            '時間をおいてもう一度お試しください。',
          ),
        );
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.UPDATE_CUSTOMER_FAILURE, error));
      dispatch(util.unLoading());
    });
};

/**
 * お届け先追加
 */
export const addCustomerAddress = (accessToken, param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/address`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((payload) => {
      if (payload.status === 201) {
        dispatch(util.actionType(CONST.ADD_ADDRESS_SUCCESS, null));
        dispatch(util.unLoading());
      } else {
        dispatch(
          util.actionType(
            CONST.ADD_ADDRESS_FAILURE,
            '時間をおいてもう一度お試しください。',
          ),
        );
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.ADD_ADDRESS_FAILURE, error));
      dispatch(util.unLoading());
    });
};
/**
 * お届け先更新
 */
export const updateCustomerAddress = (accessToken, id, param) => (dispatch) => {
  dispatch(util.loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/address/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((payload) => {
      if (payload.status === 200) {
        dispatch(util.actionType(CONST.UPDATE_ADDRESS_SUCCESS, null));
        dispatch(util.unLoading());
      } else {
        dispatch(
          util.actionType(
            CONST.UPDATE_ADDRESS_FAILURE,
          ),
        );
        dispatch(util.unLoading());
      }
    })
    .catch((error) => {
      dispatch(util.actionType(CONST.UPDATE_ADDRESS_FAILURE, error));
      dispatch(util.unLoading());
    });
};
/**
 * 結果フラグクリア
 */
export const clearResultFlg = () => (dispatch) => {
  dispatch(util.actionType(CONST.CLEAR_MYPAGE_RESULT_FLG, null));
};
